import classes from './Vienna_text.module.css';
import {useEffect, useState} from "react";
import {Button, CircularProgress, TextField} from "@mui/material";
import axios from "axios";
import {path} from "../../../routes";

const Vienna_text = (props) => {
    const [loading, setLoading] = useState(false);
    const [textA, setTextA] = useState("");
    const [textB, setTextB] = useState("");

    const updateText = async (id, newText) => {
        setLoading(true);
        try {
            const response = await fetch(`${path}/updateText`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ id, text: newText }),
            });

            if (!response.ok) {
                throw new Error("Chyba při aktualizaci textu");
            }
            setLoading(false)
            alert("Text úspěšně aktualizován");
        } catch (error) {
            console.error("Chyba při odesílání požadavku:", error);
            alert("Nepodařilo se aktualizovat text");
        }
    };

    const fetchText = async (gr) => {
        setLoading(true);
        try {
            const response = await axios.get(`${path}/getTexts`);
            //console.log(response.data);
            setTextA(response.data[0].text)
            setTextB(response.data[1].text)
            // Optionally, update your UI to reflect the deletion
            setLoading(false
            )
        } catch (error) {
            console.error('Error deleting row:', error);
        }
    }
    useEffect(() => {
        //console.warn("ajojda")
        fetchText()
    }, [])

    return <div className={classes.main}>
        <div className={classes.container}>
            {loading && <CircularProgress sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 10 }} />}
            <div className={classes.head}>
                <h2>SLEEP - left side</h2>
            </div>
            <div className={classes.body}>
                <TextField
                    fullWidth
                    id="outlined-multiline-static"
                    label="Text"
                    multiline
                    rows={5}
                    value={textA}
                    onChange={(e) => setTextA(e.target.value)}
                    disabled={loading}
                    sx={{ width: '100%' }}
                />
            </div>
            <div className={classes.footer}>
                {!loading && <Button sx={{width: { xs: "100%", sm: "50%" }}} variant="outlined" onClick={()=>{updateText(1,textA)}}>Update</Button>}
            </div>
        </div>
        <div className={classes.container}>
            {loading && <CircularProgress sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 10 }} />}
            <div className={classes.head}>
                <h2>SLEEP - right side</h2>
            </div>
            <div className={classes.body}>
                <TextField
                    fullWidth
                    id="outlined-multiline-static-2"
                    label="Text"
                    multiline
                    rows={5}
                    value={textB}
                    onChange={(e) => setTextB(e.target.value)}
                    disabled={loading}
                    sx={{ width: '100%' }}
                />
            </div>
            <div className={classes.footer}>
                {!loading && <Button sx={{width: { xs: "100%", sm: "50%" }}} variant="outlined" onClick={()=>{updateText(2,textB)}}>Update</Button>}
            </div>
        </div>
    </div>
}
export default Vienna_text;